export const steps_image3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    clipRule="evenodd"
    viewBox="0 0 611 437"
  >
    <g transform="translate(-69.732 -31.76)">
      <g>
        <path
          fill="#E7F0F1"
          fillRule="nonzero"
          d="M0 18.276c.09 41.008 21.949 81.345 56.256 103.812 50.478 33.055 116.804 25.543 174.387 43.571 41.434 12.971 78.208 39.22 120.611 48.546 44.748 9.842 91.85-.232 134.05-18.078 55.798-23.599 109.147-65.968 121.982-125.175 6.401-29.53 2.095-60.203-2.232-90.108-6.655-45.992-14.013-93.833-40.495-132.019-8.401-12.113-19.116-23.341-32.944-28.45-13.827-5.108-31.196-2.66-40.466 8.803-10.125 12.519-8.547 32.041-19.784 43.573-9.901 10.163-26.702 10.29-39.743 4.701-13.041-5.589-23.477-15.722-34.483-24.676-49.442-40.222-116.07-58.547-179.126-49.267-58.803 8.655-106.954 40.269-146.65 83.188C37.577-76.773-.115-34.173 0 18.276"
          transform="translate(69.732 241.092)"
        ></path>
        <path
          fill="#E7F0F1"
          fillRule="nonzero"
          d="M0 47.329c-4.252 4.656-10.326 7.397-16.55 8.411-11.688 1.905-24.283-2.329-32.184-11.151-7.902-8.822-10.707-22.014-6.746-33.176C-51.521.252-40.817-8.297-29.021-9.35c10.826-.966 22.047 5.201 29.7 12.576C7.127 9.441 7.68 18.987 7.278 27.471 6.94 34.601 4.907 41.955 0 47.329"
          transform="translate(530.662 41.21)"
        ></path>
        <path
          fill="#3E4E6D"
          fillRule="nonzero"
          d="M0-9.94a2.484 2.484 0 00-2.484-2.485h-429.41a2.484 2.484 0 100 4.969h15.643a2.486 2.486 0 010 4.971h-5.59a2.485 2.485 0 100 4.97h409.303a2.485 2.485 0 000-4.97h-5.59a2.485 2.485 0 110-4.971h15.644A2.484 2.484 0 000-9.94"
          transform="translate(671.234 386.416)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M25.481-250.152h223.175l49.463 280.519H74.944L25.481-250.152z"
          transform="scale(1 -1) rotate(-80 228.99 -376.577)"
        ></path>
        <path
          fill="#E86164"
          fillRule="nonzero"
          d="M-277.538-41.433H7.307L.002 0h-284.847l7.307-41.433z"
          transform="matrix(-1 0 0 1 318.157 154.206)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M-84.341 12.028H-2.12L0 0h-82.22l-2.121 12.028z"
          transform="matrix(-1 0 0 1 420.644 160.872)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.138 0-4.176-1.732-4.553-3.87l-4.11-23.308C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(369.118 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.137 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.921 0-28.783 0h23.308C-3.338 0-1.3 1.733-.923 3.87l4.111 23.308c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(407.031 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.136 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(444.944 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(482.857 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.347 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.377 2.138-1.05 3.87-3.188 3.87"
          transform="translate(520.771 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.137 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.921 0-28.783 0h23.308C-3.338 0-1.3 1.733-.923 3.87l4.111 23.308c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(558.685 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.136 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(596.598 183.414)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.138 0-4.176-1.732-4.553-3.87l-4.11-23.308C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(375.684 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(413.597 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(451.51 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.137 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.921 0-28.783 0h23.307C-3.338 0-1.3 1.733-.923 3.87l4.111 23.308c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(489.424 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.136 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.921 0-28.783 0h23.308c2.137 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(527.337 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.136 0-4.174-1.732-4.551-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(565.25 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(603.163 220.65)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.97 3.87C-32.347 1.734-30.92 0-28.783 0h23.308c2.138 0 4.176 1.734 4.553 3.87l4.11 23.309c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(382.249 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.97 3.87C-32.347 1.734-30.92 0-28.782 0h23.307c2.138 0 4.176 1.734 4.553 3.87l4.11 23.309c.377 2.138-1.05 3.87-3.188 3.87"
          transform="translate(420.162 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.309c-2.136 0-4.175-1.732-4.552-3.87l-4.11-23.309C-32.348 1.734-30.921 0-28.783 0h23.308c2.137 0 4.176 1.734 4.552 3.87l4.111 23.309c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(458.076 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.309c-2.136 0-4.174-1.732-4.551-3.87L-31.971 3.87C-32.348 1.734-30.92 0-28.783 0h23.308c2.138 0 4.176 1.734 4.553 3.87l4.11 23.309c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(495.989 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.734-30.92 0-28.782 0h23.307c2.138 0 4.176 1.734 4.553 3.87l4.11 23.309c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(533.902 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.97 3.87C-32.347 1.734-30.92 0-28.782 0h23.307c2.138 0 4.176 1.734 4.553 3.87l4.11 23.309c.377 2.138-1.05 3.87-3.188 3.87"
          transform="translate(571.815 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.309c-2.137 0-4.175-1.732-4.552-3.87l-4.11-23.309C-32.348 1.734-30.921 0-28.783 0h23.308c2.137 0 4.176 1.734 4.552 3.87l4.111 23.309c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(609.73 257.887)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.137 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.92 0-28.783 0h23.308C-3.338 0-1.3 1.733-.923 3.87l4.111 23.308c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(388.815 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.136 0-4.175-1.732-4.551-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(426.728 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(464.642 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.97 3.87C-32.347 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.377 2.138-1.05 3.87-3.188 3.87"
          transform="translate(502.555 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.137 0-4.175-1.732-4.552-3.87l-4.11-23.308C-32.348 1.733-30.921 0-28.783 0h23.308C-3.338 0-1.3 1.733-.923 3.87l4.111 23.308c.376 2.138-1.051 3.87-3.188 3.87"
          transform="translate(540.469 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.309c-2.136 0-4.175-1.732-4.551-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(578.382 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.048h-23.308c-2.137 0-4.175-1.732-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.308c.376 2.138-1.05 3.87-3.188 3.87"
          transform="translate(616.295 295.124)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.176-1.733-4.553-3.87l-4.11-23.309C-32.347 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.309c.376 2.137-1.05 3.87-3.188 3.87"
          transform="translate(395.381 332.36)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.733-4.552-3.87L-31.971 3.87C-32.347 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.309c.377 2.137-1.05 3.87-3.188 3.87"
          transform="translate(433.294 332.36)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.309c-2.137 0-4.175-1.733-4.552-3.87l-4.11-23.309C-32.348 1.733-30.921 0-28.783 0h23.307C-3.338 0-1.3 1.733-.923 3.87l4.111 23.309c.376 2.137-1.051 3.87-3.188 3.87"
          transform="translate(471.208 332.36)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.309c-2.137 0-4.175-1.733-4.552-3.87l-4.11-23.309C-32.348 1.733-30.92 0-28.783 0h23.308c2.137 0 4.176 1.733 4.553 3.87l4.11 23.309c.376 2.137-1.051 3.87-3.188 3.87"
          transform="translate(509.121 332.36)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.733-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.783 0h23.308c2.138 0 4.176 1.733 4.553 3.87l4.11 23.309c.376 2.137-1.05 3.87-3.188 3.87"
          transform="translate(547.034 332.36)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.308c-2.137 0-4.175-1.733-4.552-3.87L-31.971 3.87C-32.348 1.733-30.92 0-28.782 0h23.307c2.138 0 4.176 1.733 4.553 3.87l4.11 23.309c.376 2.137-1.05 3.87-3.188 3.87"
          transform="translate(584.947 332.36)"
        ></path>
        <path
          fill="#63E5FF"
          fillRule="nonzero"
          d="M0 31.049h-23.309c-2.137 0-4.175-1.733-4.552-3.87l-4.11-23.309C-32.348 1.733-30.921 0-28.783 0h23.307C-3.338 0-1.3 1.733-.923 3.87l4.111 23.309c.376 2.137-1.051 3.87-3.188 3.87"
          transform="translate(622.861 332.36)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 340.263 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.233 7.824-14.292 18.352h4.92C-8.447-32.767-4.531-38.654 0-38.654c5.193 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.544 16.779A5.283 5.283 0 010-4.884a5.39 5.39 0 01-1.708-.287c-1.188.472-1.884 1.685-1.631 3.121.111.632.4 1.217.794 1.721C-1.72-.117-.871 0 0 0c1.113 0 2.19-.186 3.225-.528C9.732-2.68 14.463-11.237 14.463-21.769 14.463-33.976 8.11-43.538 0-43.538"
          transform="translate(340.263 137.958)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 378.846 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.234 7.824-14.293 18.352h4.921C-8.448-32.767-4.531-38.654 0-38.654c5.192 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.545 16.779A5.273 5.273 0 010-4.884a5.39 5.39 0 01-1.708-.287c-1.188.472-1.885 1.685-1.632 3.121.112.632.401 1.217.795 1.721A10.19 10.19 0 000 0c1.112 0 2.189-.186 3.225-.528C9.731-2.68 14.463-11.237 14.463-21.769c0-12.207-6.354-21.769-14.463-21.769"
          transform="translate(378.847 137.958)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 417.429 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.233 7.824-14.293 18.352h4.921C-8.447-32.767-4.531-38.654 0-38.654c5.192 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.545 16.779A5.273 5.273 0 010-4.884a5.39 5.39 0 01-1.708-.287c-1.188.472-1.885 1.685-1.632 3.121.111.632.401 1.217.795 1.721A10.19 10.19 0 000 0c1.112 0 2.189-.186 3.225-.528C9.731-2.68 14.463-11.237 14.463-21.769c0-12.207-6.354-21.769-14.463-21.769"
          transform="translate(417.43 137.958)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 456.012 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.233 7.824-14.293 18.352h4.921C-8.447-32.767-4.531-38.654 0-38.654c5.192 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.545 16.779A5.273 5.273 0 010-4.884a5.39 5.39 0 01-1.708-.287c-1.188.472-1.885 1.685-1.632 3.121.111.632.401 1.217.795 1.721A10.19 10.19 0 000 0c1.112 0 2.19-.186 3.225-.528C9.731-2.68 14.463-11.237 14.463-21.769c0-12.207-6.354-21.769-14.463-21.769"
          transform="translate(456.013 137.958)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 494.595 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.233 7.824-14.293 18.352h4.921C-8.447-32.767-4.531-38.654 0-38.654c5.192 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.545 16.779A5.273 5.273 0 010-4.884a5.39 5.39 0 01-1.708-.287c-1.188.472-1.885 1.685-1.632 3.121.111.632.401 1.217.795 1.721C-1.72-.117-.871 0 0 0c1.112 0 2.19-.186 3.225-.528C9.731-2.68 14.463-11.237 14.463-21.769c0-12.207-6.354-21.769-14.463-21.769"
          transform="translate(494.596 137.958)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 533.178 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.233 7.824-14.293 18.352h4.921C-8.447-32.767-4.531-38.654 0-38.654c5.192 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.545 16.779A5.273 5.273 0 010-4.884a5.39 5.39 0 01-1.708-.287c-1.188.472-1.885 1.685-1.632 3.121.112.632.401 1.217.795 1.721A10.19 10.19 0 000 0c1.112 0 2.19-.186 3.225-.528C9.731-2.68 14.463-11.237 14.463-21.769 14.463-33.976 8.11-43.538 0-43.538"
          transform="translate(533.179 137.958)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M-3.339-3.339c-1.844-.326-3.339.906-3.339 2.75 0 1.845 1.495 3.603 3.339 3.929 1.844.325 3.338-.907 3.338-2.751 0-1.844-1.494-3.603-3.338-3.928"
          transform="matrix(0 -1 -1 0 571.761 132.569)"
        ></path>
        <path
          fill="#C4D3D8"
          fillRule="nonzero"
          d="M0-43.538c-7.336 0-13.233 7.824-14.293 18.352h4.921C-8.447-32.767-4.531-38.654 0-38.654c5.192 0 9.579 7.732 9.579 16.885 0 8.537-3.817 15.836-8.545 16.779A5.273 5.273 0 010-4.884a5.394 5.394 0 01-1.708-.287c-1.188.472-1.885 1.685-1.632 3.121.111.632.401 1.217.795 1.721C-1.72-.117-.871 0 0 0c1.112 0 2.19-.186 3.225-.528C9.731-2.68 14.463-11.237 14.463-21.769 14.463-33.976 8.11-43.538 0-43.538"
          transform="translate(571.762 137.958)"
        ></path>
        <path
          fill="#0093B2"
          fillRule="nonzero"
          d="M-128.625-153.289h265.248l-15.997 90.72-249.251-90.72z"
          transform="scale(-1 1) rotate(80 -378.278 -128.842)"
        ></path>
        <path
          fill="#008199"
          fillRule="nonzero"
          d="M-106.924-171.499h52.288L145.48-98.66l-3.153 17.883-249.251-90.722z"
          transform="scale(-1 1) rotate(80 -378.28 -150.88)"
        ></path>
        <path
          fill="#3E4E6D"
          fillRule="nonzero"
          d="M0 336.529h-150.318c-8.069 0-14.61-6.541-14.61-14.61V14.611c0-8.07 6.541-14.611 14.61-14.611H0c8.069 0 14.61 6.541 14.61 14.611v307.308c0 8.069-6.541 14.61-14.61 14.61"
          transform="translate(287.42 83.61)"
        ></path>
        <path
          fill="#3E4E6D"
          fillRule="nonzero"
          d="M-1.422-.046a2.649 2.649 0 00-2.444 2.839l2.444 32.843a2.647 2.647 0 002.837 2.444L-1.422-.046z"
          transform="scale(1 -1) rotate(4.256 2478.216 1577.545)"
        ></path>
        <path
          fill="#3E4E6D"
          fillRule="nonzero"
          d="M1.226-38.277a2.648 2.648 0 00-2.444 2.838L1.226-2.596A2.647 2.647 0 004.063-.151L1.226-38.277z"
          transform="scale(-1 1) rotate(4.256 -2724.159 -4023.23)"
        ></path>
        <path
          fill="#3E4E6D"
          fillRule="nonzero"
          d="M-1.422-.046a2.648 2.648 0 00-2.444 2.838l2.444 32.843a2.647 2.647 0 002.837 2.445L-1.422-.046z"
          transform="scale(1 -1) rotate(4.256 3054.84 1556.069)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M0-326.789h-23.681l-4.376 13.388a14.61 14.61 0 01-13.887 10.07h-66.429a14.61 14.61 0 01-13.887-10.07l-4.376-13.388h-23.681c-5.379 0-9.741 4.361-9.741 9.741V-9.74c0 5.379 4.362 9.74 9.741 9.74H0c5.38 0 9.741-4.361 9.741-9.74v-307.308A9.74 9.74 0 000-326.789"
          transform="translate(287.42 415.269)"
        ></path>
        <path
          fill="#442848"
          fillRule="nonzero"
          d="M0 5.195h-24.513a2.598 2.598 0 110-5.195H0a2.597 2.597 0 110 5.195"
          transform="translate(219.384 95.542)"
        ></path>
        <path
          fill="#442848"
          fillRule="nonzero"
          d="M-2.597-2.598a2.598 2.598 0 100 5.196 2.598 2.598 0 000-5.196"
          transform="matrix(0 -1 -1 0 229.651 95.543)"
        ></path>
        <path
          fill="#00728A"
          d="M169.258 347.96H255.26500000000001V351.22799999999995H169.258z"
          transform="matrix(-1 0 0 1 424.523 -199.188)"
        ></path>
        <path
          fill="#00728A"
          d="M183.782 342.274H240.741V345.543H183.782z"
          transform="matrix(-1 0 0 1 424.523 -187.817)"
        ></path>
        <g fill="#00728A" fillRule="nonzero">
          <path
            d="M179.357 144.963v-7.9h3.25l5.965 4.808h-1.508v-4.808h3.854v7.9h-3.25l-5.966-4.808h1.508v4.808h-3.853zM191.555 144.963l5.127-7.9h3.888l5.127 7.9h-4.088l-3.787-6.636h1.541l-3.786 6.636h-4.022zm3.05-1.377l1.005-1.918h5.396l1.005 1.918h-7.406zM206.334 144.963v-7.9h5.647c1.095 0 2.041.121 2.84.362.799.24 1.416.584 1.852 1.032a2.2 2.2 0 01.653 1.586c0 .609-.218 1.136-.653 1.58-.436.443-1.053.788-1.852 1.032-.799.245-1.745.367-2.84.367h-3.452l1.759-1.14v3.081h-3.954zm3.954-2.787l-1.759-1.208h3.2c.548 0 .953-.083 1.215-.248.263-.166.394-.391.394-.677 0-.286-.131-.512-.394-.677-.262-.166-.667-.249-1.215-.249h-3.2l1.759-1.207v4.266zM220.912 144.963v-5.834h-3.435v-2.066h10.824v2.066h-3.435v5.834h-3.954zM227.464 144.963l5.127-7.9h3.887l5.128 7.9h-4.089l-3.787-6.636h1.542l-3.787 6.636h-4.021zm3.049-1.377l1.006-1.918h5.395l1.005 1.918h-7.406zm2.262-7.166l2.212-1.805h3.603l-3.301 1.805h-2.514zM242.243 144.963v-7.9h5.646c1.095 0 2.042.121 2.841.362.798.24 1.415.584 1.851 1.032.436.448.654.976.654 1.586a2.16 2.16 0 01-.654 1.574c-.436.44-1.053.777-1.851 1.01-.799.233-1.746.35-2.841.35h-3.451l1.759-1.095v3.081h-3.954zm7.02 0l-2.882-2.878h4.189l2.916 2.878h-4.223zm-3.066-2.787l-1.759-1.208h3.2c.547 0 .952-.083 1.215-.248.262-.166.394-.391.394-.677 0-.286-.132-.512-.394-.677-.263-.166-.668-.249-1.215-.249h-3.2l1.759-1.207v4.266z"
            transform="matrix(.67348 0 0 1 65.695 0)"
          ></path>
        </g>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.617 2.617 0 010 16.867"
          transform="translate(155.699 166.386)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(176.492 166.386)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.618 2.618 0 012.618 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(197.285 166.386)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(218.078 166.386)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(238.871 166.386)"
        ></path>
        <path
          fill="#00B4C7"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.617 2.617 0 010 16.867"
          transform="translate(259.663 166.386)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(280.456 166.386)"
        ></path>
        <path
          fill="#FFD164"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(155.699 186.835)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(176.492 186.835)"
        ></path>
        <path
          fill="#FFD16B"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.618 2.618 0 012.618 2.617V14.25A2.618 2.618 0 010 16.867"
          transform="translate(197.285 186.835)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(218.078 186.835)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(238.871 186.835)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(259.663 186.835)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(280.456 186.835)"
        ></path>
        <path
          fill="#A0F55A"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(155.699 207.284)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(176.492 207.284)"
        ></path>
        <path
          fill="#00B4C7"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.618 2.618 0 012.618 2.617V14.25A2.618 2.618 0 010 16.867"
          transform="translate(197.285 207.284)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(218.078 207.284)"
        ></path>
        <path
          fill="#BAF467"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(238.871 207.284)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(259.663 207.284)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(280.456 207.284)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.617 2.617 0 010 16.867"
          transform="translate(155.699 227.733)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(176.492 227.733)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.618 2.618 0 012.618 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(197.285 227.733)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(218.078 227.733)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(238.871 227.733)"
        ></path>
        <path
          fill="#11BCCD"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.617 2.617 0 010 16.867"
          transform="translate(259.663 227.733)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.618V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617v11.632A2.618 2.618 0 010 16.867"
          transform="translate(280.456 227.733)"
        ></path>
        <path
          fill="#00B4C7"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(155.699 248.182)"
        ></path>
        <path
          fill="#EBEBEB"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(176.492 248.182)"
        ></path>
        <path
          fill="#FFD16B"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.618 2.618 0 012.618 2.617V14.25A2.618 2.618 0 010 16.867"
          transform="translate(197.285 248.182)"
        ></path>
        <path
          fill="#99F0FF"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(218.078 248.182)"
        ></path>
        <path
          fill="#99F0FF"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(238.871 248.182)"
        ></path>
        <path
          fill="#A0F55A"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(259.663 248.182)"
        ></path>
        <path
          fill="#99F0FF"
          fillRule="nonzero"
          d="M0 16.867h-11.632a2.618 2.618 0 01-2.618-2.617V2.617A2.618 2.618 0 01-11.632 0H0a2.617 2.617 0 012.617 2.617V14.25A2.617 2.617 0 010 16.867"
          transform="translate(280.456 248.182)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          stroke="#00728A"
          strokeWidth="1"
          d="M0 33.772h-128.355a6.634 6.634 0 01-6.634-6.634V6.634A6.634 6.634 0 01-128.355 0H0a6.634 6.634 0 016.634 6.634v20.504A6.634 6.634 0 010 33.772"
          transform="translate(276.439 277.295)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          stroke="#00728A"
          strokeWidth="1"
          d="M0 33.771h-128.355a6.634 6.634 0 01-6.634-6.634V6.633A6.633 6.633 0 01-128.355 0H0a6.633 6.633 0 016.634 6.633v20.504A6.634 6.634 0 010 33.771"
          transform="translate(276.439 318.451)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          stroke="#00728A"
          strokeWidth="1"
          d="M0 33.771h-128.355a6.634 6.634 0 01-6.634-6.634V6.633A6.633 6.633 0 01-128.355 0H0a6.633 6.633 0 016.634 6.633v20.504A6.634 6.634 0 010 33.771"
          transform="translate(276.439 359.605)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 203.688H272.13800000000003V206.845H148.661z"
          transform="matrix(-1 0 0 1 420.799 89.467)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 196.756H214.03300000000002V199.912H148.661z"
          transform="matrix(-1 0 0 1 362.694 103.332)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 170.019H272.13800000000003V173.17600000000002H148.661z"
          transform="matrix(-1 0 0 1 420.799 156.805)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 163.086H272.13800000000003V166.24200000000002H148.661z"
          transform="matrix(-1 0 0 1 420.799 170.672)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 156.153H214.03300000000002V159.309H148.661z"
          transform="matrix(-1 0 0 1 362.694 184.538)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 128.864H272.13800000000003V132.02100000000002H148.661z"
          transform="matrix(-1 0 0 1 420.799 239.115)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 121.932H272.13800000000003V125.08800000000001H148.661z"
          transform="matrix(-1 0 0 1 420.799 252.98)"
        ></path>
        <path
          fill="#5D5D5D"
          d="M148.661 114.998H183.624V118.155H148.661z"
          transform="matrix(-1 0 0 1 332.285 266.847)"
        ></path>
        <path
          fill="#00728A"
          fillRule="nonzero"
          d="M0 130.789l-79.926 24.009h-51.493l.561-77.714-6.685 28.747-36.524-17.059 22.194-65.776a35.994 35.994 0 0113.876-18.264l20.912-14.209 13.15.949 29.222-15.481 47.995 19.33L0 130.789z"
          transform="translate(623.117 287.572)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M0 18.296l-5.012-47.043-1.608 11.238a105.36 105.36 0 00-.618 24.64l.717 7.77c.337 3.65-.042 7.33-1.117 10.833l-5.597 18.249 6.55 3.06L0 18.296z"
          transform="translate(492.259 346.36)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M0-140.52c-4.575 4.401-9.313 17.313-10.143 21.934L1.27-43.281l-52.995 37.12L-42.643 0l79.926-24.009-22.532-114.247L0-140.52z"
          transform="translate(585.834 442.371)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M0-163.326l.463 3.924a33.618 33.618 0 003.557 11.561l2.376 4.575-2.588 5.086a9.464 9.464 0 00.76 9.836l1.828 2.532 8.214 62.55L14.927 0l-.218-.693a117.361 117.361 0 01-2.151-62.569l-.727-1.767a121.026 121.026 0 01-8.298-59.728c-5.181-4.322-6.11-11.928-2.118-17.37l.835-1.139a26.85 26.85 0 01-2.771-16.827L0-163.326z"
          transform="translate(519.183 442.37)"
        ></path>
        <path
          fill="#FFA68E"
          fillRule="nonzero"
          d="M0 34.346l10.917-19.62L-20.612 0 0 34.346z"
          transform="translate(469.662 376.344)"
        ></path>
        <path
          fill="#004456"
          fillRule="nonzero"
          d="M0-23.851L31.529-9.125 26.452 0 0-23.851z"
          transform="translate(449.05 400.196)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M0-42.353l12.328 1.105-13.855 54.68c-2.507 9.895 2.889 20.078 12.484 23.559 13.194 4.786 27.057-5.245 26.636-19.274l-1.888-62.913a55.04 55.04 0 006.04-29.948l-.264-3.196a5.31 5.31 0 00-3.414-4.53l-1.878-.71a5.312 5.312 0 00-4.451.325l-9.381 5.204.434.811a8.535 8.535 0 009.952 4.164l-8.253 7.661L0-42.353z"
          transform="translate(433.571 384.737)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M0 43.336l-23.085-45.47a5.688 5.688 0 00-5.07-3.112h-23.592c-.648 0-1.182.321-1.519.782l-.004-.003-2.62 3.521h3.239l22.298 43.924a5.69 5.69 0 005.072 3.112h21.22l1.458 2.492 2.528-3.396A1.88 1.88 0 000 43.336"
          transform="translate(465.352 287.844)"
        ></path>
        <path
          fill="#3E4E6D"
          fillRule="nonzero"
          d="M0 51.336h-23.591a5.684 5.684 0 01-5.07-3.112l-23.085-45.47A1.895 1.895 0 01-50.057 0h23.592a5.685 5.685 0 015.07 3.112L1.69 48.583A1.895 1.895 0 010 51.336"
          transform="translate(461.134 285.993)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M0-11.215h-8.744a.949.949 0 00-.846 1.377l4.468 8.801A1.895 1.895 0 00-3.432 0h8.744a.947.947 0 00.846-1.376L1.69-10.177A1.894 1.894 0 000-11.215"
          transform="translate(421.366 299.104)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M0-5.553l15.104-10.441a2.878 2.878 0 014.115.903L26.03-3.563c.53.895.534 2.006.013 2.906l-3.925 6.78a10.558 10.558 0 01-9.139 5.268 3.428 3.428 0 01-2.864-1.545L0-5.553z"
          transform="translate(420.592 330.993)"
        ></path>
        <path
          fill="#FFA68E"
          fillRule="nonzero"
          d="M0-2.934l-.438-.865L-5.495.865 0-2.934z"
          transform="translate(426.087 324.575)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M0-1.612l10.723-6.691a3.992 3.992 0 014.822 6.323l-9.94 9.169a1.688 1.688 0 01-2.603-.392L-.565.67A1.689 1.689 0 010-1.612"
          transform="translate(414.986 318.251)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M0 7.307l2.725 12.005 10.425 9.162L33.368 3.517l-6.16-24.684L0 7.307z"
          transform="translate(506.032 250.57)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M0-13.674c.621-3.903.772-7.849.72-11.804L-24.95 1.387l2.364 10.417c4.924-.382 9.772-2.691 13.368-6.15C-3.981.618-1.14-6.499 0-13.674"
          transform="translate(530.982 256.49)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M7.223-9.543h24.445L15.887 22.371l-13.072-.099L7.223-9.543z"
          transform="scale(1 -1) rotate(-46.9 -47.446 -734.42)"
        ></path>
        <path
          fill="#004656"
          fillRule="nonzero"
          d="M-8.805-22.866h8.654l19.082 9.201-22.323 3.579-5.413-12.78z"
          transform="scale(-1 1) rotate(71.647 -461.56 -222.795)"
        ></path>
        <path
          fill="#1E1E1E"
          fillRule="nonzero"
          d="M0 62.41c-5.051-2.94-8.959-7.788-10.761-13.347-1.802-5.558-1.151-11.934 1.213-17.278-8.091-2.318-14.497-9.678-15.677-18.011-1.18-8.334 2.931-17.183 10.06-21.656-.407 1.298-.049 3.378.768 4.467.816 1.089 2 1.85 3.235 2.421C-6.825 1.008-1.754.852 2.874-.331c4.629-1.183 8.944-3.322 13.325-5.226 4.381-1.906 8.953-3.609 13.726-3.834 8.095-.383 16.248 3.886 20.544 10.758 5.332-1.229 11.798.635 15.97 4.174 4.618 3.918 6.907 9.915 8.3 15.808 3.181 13.446 2.576 27.766-1.724 40.897-1.699 5.185-9.051 5.855-14.449 6.651C39.348 71.733 16.789 72.184 0 62.41"
          transform="translate(466.597 167.215)"
        ></path>
        <path
          fill="#1E1E1E"
          fillRule="nonzero"
          d="M0 4.264c1.384 2.963 4.388 4.958 7.571 5.704 3.185.747 6.536.377 9.711-.408 5.723-1.414 11.024-4.124 16.38-6.584C39.02.517 44.604-1.739 50.484-2.143 56.365-2.547 63.49.288 67.41 4.69 63.114-2.181 54.961-6.451 46.866-6.068c-4.772.226-9.345 1.929-13.725 3.834-4.381 1.905-8.697 4.043-13.326 5.227-4.627 1.183-9.699 1.339-14.036-.664C4.544 1.759 3.36.997 2.544-.091 1.728-1.18 1.369-3.26 1.776-4.559-.781-2.52-1.384 1.301 0 4.264"
          transform="translate(449.655 163.891)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M0 5.57a5.247 5.247 0 01-3.436-4.216l-1.147-8.21a6.849 6.849 0 00-3.386-4.999l-1.647-.942a6.851 6.851 0 01-3.435-5.457l-1.475-20.523c-14.28 8.172-30.515 12.742-46.943 13.293a34.031 34.031 0 00-1.765 20.338l4.267 19.385c4.062 18.447 22.308 30.108 40.754 26.046C-2.757 36.882 7.93 23.519 8.601 8.425L0 5.57z"
          transform="translate(523.915 224.942)"
        ></path>
        <path
          fill="#1E1E1E"
          fillRule="nonzero"
          d="M0-5.834c-4.338.383-7.997 2.799-10.155 6.217l21.242-1.875C8.363-4.48 4.337-6.217 0-5.834"
          transform="translate(495.729 215.264)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M0-6.128a2.546 2.546 0 00-2.545 2.545v1.038a2.545 2.545 0 005.09 0v-1.038A2.545 2.545 0 000-6.128"
          transform="translate(494.804 228.205)"
        ></path>
        <path
          fill="#1E1E1E"
          fillRule="nonzero"
          d="M0-6.282c-3.117.79-5.368 3.51-6.333 7.072l15.27-3.868C6.393-5.751 3.118-7.072 0-6.282"
          transform="translate(466.208 220.028)"
        ></path>
        <path
          fill="#47284F"
          fillRule="nonzero"
          d="M0-5.354a2.25 2.25 0 00-1.864 2.582l.146.907a2.253 2.253 0 004.447-.718l-.147-.907A2.251 2.251 0 000-5.354"
          transform="translate(469.102 232.08)"
        ></path>
        <path
          fill="#FFA68E"
          fillRule="nonzero"
          d="M0-5.638l-10.315 1.357C-9.654-1.953-7.327 0-4.917-.22-2.507-.439-.23-3.229 0-5.638"
          transform="translate(487.067 247.484)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M-12.306-18.202A121.941 121.941 0 00-2.855.829c-3.101.934-6.819.549-9.451-1.337-2.632-1.887-4.317-5.034-4.43-8.27-.113-3.237 1.936-7.359 4.43-9.424"
          transform="scale(-1 1) rotate(-43.033 73.594 739.047)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M-11.807-11.807c-6.521 0-11.807 5.286-11.807 11.808 0 6.52 5.286 11.806 11.807 11.806C-5.286 11.807 0 6.521 0 .001c0-6.522-5.286-11.808-11.807-11.808"
          transform="matrix(0 -1 -1 0 535.886 213.334)"
        ></path>
        <path
          fill="#FFA68E"
          fillRule="nonzero"
          d="M-6.573-6.573a6.573 6.573 0 100 13.146 6.573 6.573 0 000-13.146"
          transform="matrix(0 -1 -1 0 535.886 218.568)"
        ></path>
        <path
          fill="#00728A"
          fillRule="nonzero"
          d="M0-107.825a19.092 19.092 0 0111.842 11.588l27.986 77.282L-2.82 0l-12.794-67.289.568-4.165A77.497 77.497 0 010-107.825"
          transform="translate(596.399 390.719)"
        ></path>
        <path
          fill="#FFC5C3"
          fillRule="nonzero"
          d="M0-64.706l3.594 12.408-67.527 35.067-31.803-11.683a4.37 4.37 0 00-4.981 1.451l-8.873 11.637a5.883 5.883 0 001.189 8.302l4.189 3.088a7.905 7.905 0 003.433 10.429l15.324 8.08a6.284 6.284 0 007.259-1.003l6.208-5.897 2.915.121a18.533 18.533 0 0014.262-5.808l81.528-22.898c12.702-3.567 20.044-16.823 16.328-29.482l-8.553-29.142L0-64.706z"
          transform="translate(598.042 453.441)"
        ></path>
        <path
          fill="#FFA68E"
          fillRule="nonzero"
          d="M-4.477 7.701h17.721l-7.923 2.538A5.147 5.147 0 01-.303 8.51l-4.174-.809z"
          transform="scale(1 -1) rotate(60.349 637.424 207.872)"
        ></path>
        <path
          fill="#004456"
          fillRule="nonzero"
          d="M-37.17-17.058H.575L1.936-7.14l-38.663-6.603-.443-3.315z"
          transform="scale(-1 1) rotate(23.963 -1254.813 -1224.551)"
        ></path>
        <g fill="#5E5E5E" fillRule="nonzero" transform="translate(0 -.379)">
          <path d="M149.06 283.673H150.712V288.573H149.06z"></path>
          <path d="M153.141 288.643c-.331 0-.638-.081-.92-.242a1.783 1.783 0 01-.676-.686c-.168-.296-.252-.649-.252-1.06 0-.411.084-.764.252-1.061.168-.296.394-.523.676-.682.282-.159.589-.238.92-.238.336 0 .612.071.826.213.215.143.374.36.476.651.103.292.154.664.154 1.117 0 .457-.047.833-.143 1.127-.096.294-.25.511-.462.651-.212.14-.496.21-.851.21zm.378-1.232a.599.599 0 00.315-.084.583.583 0 00.224-.256.938.938 0 00.084-.416.916.916 0 00-.084-.417.596.596 0 00-.224-.248.599.599 0 00-.315-.084.604.604 0 00-.315.084.602.602 0 00-.224.248.916.916 0 00-.084.417c0 .163.028.302.084.416a.59.59 0 00.224.256.604.604 0 00.315.084zm.672 1.162v-.518l-.007-1.4-.07-1.4v-1.876h1.582v5.194h-1.505zM158.419 288.643c-.434 0-.817-.085-1.151-.256a1.984 1.984 0 01-.788-.703 1.87 1.87 0 01-.287-1.029c0-.387.096-.73.287-1.029.192-.299.454-.532.788-.7a2.526 2.526 0 011.151-.252c.434 0 .819.084 1.155.252.336.168.599.401.788.7.189.299.283.642.283 1.029 0 .387-.094.73-.283 1.029a1.95 1.95 0 01-.788.703 2.511 2.511 0 01-1.155.256zm0-1.232a.599.599 0 00.315-.084.583.583 0 00.224-.256.938.938 0 00.084-.416.916.916 0 00-.084-.417.596.596 0 00-.224-.248.599.599 0 00-.315-.084.604.604 0 00-.315.084.602.602 0 00-.224.248.916.916 0 00-.084.417c0 .163.028.302.084.416a.59.59 0 00.224.256.604.604 0 00.315.084zm.273-3.087l.364-1.12h1.365l-.679 1.12h-1.05zm-1.638 0l.364-1.12h1.365l-.679 1.12h-1.05zM163.697 288.643c-.331 0-.605-.071-.822-.214-.217-.142-.377-.359-.48-.651-.102-.291-.154-.663-.154-1.116 0-.462.048-.839.144-1.131.096-.291.251-.507.465-.647.215-.14.497-.21.847-.21a1.794 1.794 0 011.596.927c.168.297.252.65.252 1.061 0 .411-.084.764-.252 1.06a1.765 1.765 0 01-.672.683c-.28.159-.588.238-.924.238zm-2.555 1.288v-5.187h1.505v.518l.007 1.4.07 1.4v1.869h-1.582zm2.177-2.52a.599.599 0 00.315-.084.59.59 0 00.224-.252.918.918 0 00.084-.413.935.935 0 00-.084-.42.59.59 0 00-.224-.252.599.599 0 00-.315-.084.604.604 0 00-.315.084.596.596 0 00-.224.252.935.935 0 00-.084.42c0 .163.028.301.084.413a.596.596 0 00.224.252.604.604 0 00.315.084zM168.065 288.643c-.434 0-.817-.085-1.151-.256a1.984 1.984 0 01-.788-.703 1.87 1.87 0 01-.287-1.029c0-.387.096-.73.287-1.029.192-.299.454-.532.788-.7a2.526 2.526 0 011.151-.252c.434 0 .819.084 1.155.252.336.168.599.401.788.7.189.299.283.642.283 1.029 0 .387-.094.73-.283 1.029a1.95 1.95 0 01-.788.703 2.511 2.511 0 01-1.155.256zm0-1.232a.599.599 0 00.315-.084.583.583 0 00.224-.256.938.938 0 00.084-.416.916.916 0 00-.084-.417.596.596 0 00-.224-.248.599.599 0 00-.315-.084.604.604 0 00-.315.084.602.602 0 00-.224.248.916.916 0 00-.084.417c0 .163.028.302.084.416a.59.59 0 00.224.256.604.604 0 00.315.084zM173.448 284.674c.294 0 .56.059.798.178a1.3 1.3 0 01.564.557c.138.252.206.579.206.98v2.184h-1.582v-1.911c0-.238-.042-.407-.126-.508a.424.424 0 00-.343-.15.616.616 0 00-.297.073.518.518 0 00-.217.242 1.062 1.062 0 00-.081.455v1.799h-1.582v-3.829h1.505v1.12l-.301-.322c.15-.289.352-.506.606-.651.254-.145.538-.217.85-.217zM177.55 288.643c-.527 0-.938-.127-1.232-.382-.294-.254-.441-.645-.441-1.172v-3.206h1.582v3.192c0 .117.032.208.095.273a.313.313 0 00.234.098.615.615 0 00.357-.105l.378 1.099c-.121.07-.267.121-.437.154-.17.033-.349.049-.536.049zm-2.198-2.534v-1.155h2.891v1.155h-2.891zM179.097 288.573v-3.64c0-.495.149-.889.445-1.183.296-.294.717-.441 1.263-.441.168 0 .338.015.508.045.17.031.314.079.43.144l-.378 1.099a1.479 1.479 0 00-.168-.063.622.622 0 00-.189-.028.37.37 0 00-.273.105c-.07.07-.105.182-.105.336v.182l.049.651v2.793h-1.582zm-.525-2.464v-1.155h2.891v1.155h-2.891zM183.892 288.643c-.434 0-.817-.085-1.151-.256a1.984 1.984 0 01-.788-.703 1.87 1.87 0 01-.287-1.029c0-.387.096-.73.287-1.029.192-.299.454-.532.788-.7a2.526 2.526 0 011.151-.252c.434 0 .819.084 1.155.252.336.168.599.401.788.7.189.299.283.642.283 1.029 0 .387-.094.73-.283 1.029a1.95 1.95 0 01-.788.703 2.511 2.511 0 01-1.155.256zm0-1.232a.599.599 0 00.315-.084.583.583 0 00.224-.256.938.938 0 00.084-.416.916.916 0 00-.084-.417.596.596 0 00-.224-.248.599.599 0 00-.315-.084.604.604 0 00-.315.084.602.602 0 00-.224.248.916.916 0 00-.084.417c0 .163.028.302.084.416a.59.59 0 00.224.256.604.604 0 00.315.084zM188.561 290.001c-.378 0-.732-.04-1.064-.119a2.62 2.62 0 01-.854-.357l.532-1.078c.15.117.34.209.571.276.231.068.449.102.654.102.327 0 .56-.069.7-.207.14-.137.21-.334.21-.591v-.322l.07-1.19.007-1.19v-.581h1.505v3.066c0 .742-.205 1.293-.616 1.652-.41.359-.982.539-1.715.539zm-.308-1.638c-.322 0-.623-.076-.903-.228a1.804 1.804 0 01-.679-.64 1.811 1.811 0 01-.259-.98c0-.378.087-.705.259-.98a1.78 1.78 0 01.679-.637c.28-.149.581-.224.903-.224.332 0 .604.065.816.196.212.131.37.332.472.605.103.273.154.62.154 1.04 0 .42-.051.766-.154 1.039-.102.273-.26.476-.472.609-.212.133-.484.2-.816.2zm.42-1.232a.717.717 0 00.336-.077.575.575 0 00.231-.217.614.614 0 00.084-.322.61.61 0 00-.084-.326.559.559 0 00-.231-.21.741.741 0 00-.336-.073.745.745 0 00-.332.073.578.578 0 00-.238.21.595.595 0 00-.088.326.594.594 0 00.326.539c.1.051.211.077.332.077z"></path>
          <path d="M191.592 283.379H193.174V288.57300000000004H191.592z"></path>
          <path d="M196.191 288.573v-.679l-.112-.182v-1.288c0-.187-.057-.329-.171-.427-.114-.098-.3-.147-.557-.147-.172 0-.347.027-.525.08a1.495 1.495 0 00-.455.221l-.504-1.043c.224-.14.493-.247.805-.322.313-.075.619-.112.917-.112.658 0 1.168.147 1.53.441.362.294.542.761.542 1.4v2.058h-1.47zm-1.085.07c-.312 0-.574-.054-.784-.161a1.143 1.143 0 01-.476-.431 1.145 1.145 0 01-.161-.598c0-.247.063-.457.189-.63s.319-.303.578-.392c.259-.089.587-.133.983-.133h.798v.763h-.546c-.168 0-.29.027-.367.08a.277.277 0 00-.116.242c0 .089.034.162.102.22.068.059.16.088.276.088a.499.499 0 00.497-.364l.203.469c-.06.285-.189.497-.385.637s-.459.21-.791.21z"></path>
          <path d="M198.347 283.379H199.929V288.57300000000004H198.347z"></path>
          <path d="M202.946 288.573v-.679l-.112-.182v-1.288c0-.187-.057-.329-.171-.427-.114-.098-.3-.147-.557-.147-.172 0-.347.027-.525.08a1.495 1.495 0 00-.455.221l-.504-1.043c.224-.14.493-.247.805-.322.313-.075.619-.112.917-.112.658 0 1.168.147 1.53.441.362.294.542.761.542 1.4v2.058h-1.47zm-1.085.07c-.312 0-.574-.054-.784-.161a1.143 1.143 0 01-.476-.431 1.145 1.145 0 01-.161-.598c0-.247.063-.457.189-.63s.319-.303.578-.392c.259-.089.587-.133.983-.133h.798v.763h-.546c-.168 0-.29.027-.367.08a.277.277 0 00-.116.242c0 .089.034.162.102.22.068.059.16.088.276.088a.499.499 0 00.497-.364l.203.469c-.06.285-.189.497-.385.637s-.459.21-.791.21zm-.07-4.319l.924-1.12h1.505l-1.379 1.12h-1.05zM206.6 288.643a4.48 4.48 0 01-.966-.105 2.772 2.772 0 01-.77-.273l.434-1.043c.182.107.394.191.634.252s.475.091.703.091c.192 0 .321-.016.389-.049s.101-.077.101-.133c0-.056-.039-.097-.119-.123a1.661 1.661 0 00-.315-.059c-.13-.014-.274-.032-.43-.053a3.877 3.877 0 01-.473-.094 1.524 1.524 0 01-.434-.189.947.947 0 01-.315-.34 1.107 1.107 0 01-.119-.542c0-.243.074-.462.221-.658.147-.196.366-.354.658-.473.292-.119.652-.178 1.081-.178.28 0 .56.026.84.077.28.051.521.131.721.238l-.434 1.043a2.127 2.127 0 00-.577-.221 2.627 2.627 0 00-.529-.059c-.2 0-.337.019-.409.056-.072.037-.109.079-.109.126 0 .056.04.098.119.126.08.028.185.049.315.063.131.014.275.031.431.052.156.021.313.054.469.098.156.045.3.109.43.193a.935.935 0 01.315.339c.08.143.119.324.119.543 0 .229-.072.442-.217.64-.144.199-.364.357-.658.476-.294.119-.662.179-1.106.179z"></path>
        </g>
      </g>
    </g>
  </svg>
);
